import React from 'react';
import { Form } from '@rocketseat/unform';
import { ContainerSuccess } from './styles';

export default function ChangePasswordSuccess() {
  return (
    <ContainerSuccess>
      <Form>
        <h2>Alterar Senha</h2>
        <div>Dados alterados com sucesso!</div>
      </Form>
    </ContainerSuccess>
  );
}
